import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";

// Resources are loaded eagerly here. To add a new fully-translated language,
// drop a JSON file under ./locales/<code>.json with the same shape as en.json,
// import it, and add to the resources map below — no application changes.
const resources = {
    en: { translation: en },
    es: { translation: es },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "en",
        supportedLngs: ["en", "es"],   // pin to MVP-translated set; falls back to English otherwise
        nonExplicitSupportedLngs: true, // "es-MX" -> "es" etc.
        interpolation: { escapeValue: false }, // React already escapes
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
            lookupLocalStorage: "vu_lang",
        },
        returnNull: false,
    });

export default i18n;
